import {
    ADD_CLIENT_REQUESTED,
    ADD_CLIENT_SUCCESS,
    GET_COUNTRY_REQUESTED,
    GET_COUNTRY_SUCCESS,
    GET_COUNTRY_FAILED,
    CLEAR_CONDITION_SUCCESS,
    CLIENT_FAILED,
} from '../actions/actionTypes'
import { defaultCountries } from '../../helpers/data-constants'

const initialState = {
    country: [...defaultCountries],
    client: {},
    loading: false,
    commonError: false,
    isBack: false,
    isLoading: false,
}

const clientAddReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CLIENT_REQUESTED:
            return {
                ...state,
                loading: true,
                commonError: false
            }
        case ADD_CLIENT_SUCCESS:
            return {
                ...state,
                loading: false,
                isBack: true,
                country: [...defaultCountries],
                client: { ...action.payload }
            }
        case GET_COUNTRY_REQUESTED:
            return {
                ...state,
                isLoading: true,
            }
        case GET_COUNTRY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                country: [...action.payload]
            }
        case GET_COUNTRY_FAILED:
            return {
                ...state,
                isLoading: false,
                commonError: action.payload,
            }
        case CLEAR_CONDITION_SUCCESS:
            return {
                ...state,
                client: {},
                country: [...defaultCountries],
                loading: false,
                commonError: false,
                isBack: false
            }
        case CLIENT_FAILED:
            return {
                ...state,
                loading: false,
                commonError: action.payload,
                isBack: false
            }

        default:
            return state
    }
}

export default clientAddReducer 